import { all, fork } from 'redux-saga/effects'
import auth from './auth/effects'
import user_session from './user_session/effects'
import app from './app/effects'
import programs from './programs/effects'
import survey from './survey/effects'
import cart from './cart/effects'
import checkin from './checkin/effects'
import organizationSetting from './organizationSetting/effects'
import sidebar from './sidebar/effects'

function* rootSaga() {
  yield all([auth, user_session, app, programs, survey, cart, checkin, organizationSetting, sidebar].map(fork))
}

export default rootSaga
